// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/Controlled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { view, deprecatedCss } from '@sail/engine';
import { Radio } from '@sail/ui';
export const Controlled = () => {
  const [checked, setChecked] = React.useState('radio1');
  return <view.div uses={[deprecatedCss`
          layout: column;
        `]}>
      <Radio onClick={() => {
      setChecked('radio1');
    }} checked={checked === 'radio1'} label="You could go with this" />
      <Radio onClick={() => {
      setChecked('radio2');
    }} checked={checked === 'radio2'} label="Or you could go with that" />
    </view.div>;
};